import unread1 from './unread1.png';
import unread2 from './unread2.png';
import unread3 from './unread3.png';
import unread4 from './unread4.png';
import unread5 from './unread5.png';
import unread5plus from './unread5plus.png';

export {
    unread1,
    unread2,
    unread3,
    unread4,
    unread5,
    unread5plus
};
